import { Loader } from "@googlemaps/js-api-loader";

import { updateSlider } from "../../components/slider";
import { addToast } from "../../components/toasts";

const MAP_MAKRER_CLASS = "mapLocation__marker";
const MAP_RADIUS_CLASS = "mapLocation__radius";
const MAP_SAVE_LOCATION_BTN = "save-location-btn";
const MAP_LOCATION_BTN = "mapLocation__location";
const MAP_RADIUS_SLIDER = "#euiSliderRange";
const MAP_RADIUS_SIZE = 10;
const MAP_DEFAULT_ZOOM = 10;
const EARTH_RADIUS = 6371;

const MADRID_LAT_LNG = {
  lat: 40.403055107688,
  lng: -3.7423395962853,
};

const LISBON_LAT_LNG = {
  lat: 38.720380053731944,
  lng: -9.141494828029863,
};

let map;
let postalCode;
let countryCode;
let lat, lng;
let townName;
let province;
let radius;

let markerElement;
let radiusElement;
let locationBtn;
let mapSaveLocationBtn;
let userCenter;
let permissionGranted = false;
let lastValidCenter;

const loader = new Loader({
  apiKey: "AIzaSyBQykEBz8GaWFptiZTEgxededq7kQvFwzQ",
  version: "weekly",
});
loader.load().then(() => {
  initGeoMap();
});

export function initGeoMap() {
  _initGeoMap();
}

function updateRadius(newRadius) {
  radius = newRadius;
  $(".mapControls__distance").text(radius);
  _updateRadius();
  _updateZoomLevel();
}

async function _initGeoMap() {
  const { _ } = await google.maps.importLibrary("maps");

  const ES_PT_BOUNDS = new google.maps.LatLngBounds(
    new google.maps.LatLng(27.642, -20.0),
    new google.maps.LatLng(43.791, 5.0)
  );

  let center;
  if (_isSpain()) {
    center = MADRID_LAT_LNG;
  }

  if (_isPortugal()) {
    center = LISBON_LAT_LNG;
  }
  map = new google.maps.Map(document.getElementById("js-gmap"), {
    center,
    streetViewControl: false,
    zoom: MAP_DEFAULT_ZOOM,
    mapTypeControl: false,
    fullscreenControl: false,
    zoomControl: false,
    styles: MAP_STYLES,
    maxZoom: 16,
    minZoom: 5,
    disableDoubleClickZoom: true,
    cameraControl: false
  });

  map;

  markerElement = document.querySelector(`.${MAP_MAKRER_CLASS}`);
  radiusElement = document.querySelector(`.${MAP_RADIUS_CLASS}`);
  locationBtn = document.querySelector(`.${MAP_LOCATION_BTN}`);
  mapSaveLocationBtn = document.querySelector(`#${MAP_SAVE_LOCATION_BTN}`);

  radius = MAP_RADIUS_SIZE;

  google.maps.event.addListener(map, "dragstart", function () {
    markerElement.classList.add("mapLocation__marker--disabled");
    radiusElement.classList.remove("mapLocation__radius--animation");
  });

  google.maps.event.addListener(map, "dragend", function () {
    setTimeout(() => {
      _setLatLngInfo();
      _updateMapUIMarkers();
    }, 500);
  });

  google.maps.event.addListener(map, "zoom_changed", function () {
    _setLatLngInfo();
    _updateMapUIMarkers();
  });

  lastValidCenter = map.getCenter();

  google.maps.event.addListener(map, "center_changed", function () {
    if (ES_PT_BOUNDS.contains(map.getCenter())) {
      lastValidCenter = map.getCenter();
      return;
    }
    map.panTo(lastValidCenter);
  });

  $("#js-gmap-zoom-out").on("click", () => {
    const newZoom = map.zoom - 1;
    map.setZoom(newZoom);
  });

  $("#js-gmap-zoom-in").on("click", () => {
    const newZoom = map.zoom + 1;
    map.setZoom(newZoom);
  });

  $(MAP_RADIUS_SLIDER).on("change", (value) => {
    const newRadius = parseInt(value.target.value);
    updateRadius(newRadius);
  });

  $(mapSaveLocationBtn).on("click", () => {
    _updateFormInfo();
  });

  _setLatLngInfo();
}

export async function initUserGeoLocation() {
  navigator.permissions
    .query({
      name: "geolocation",
    })
    .then((permission) => {
      if (permission?.state !== "denied" && !permissionGranted) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            userCenter = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            map.setCenter(userCenter);
            setTimeout(() => {
              _setLatLngInfo();
              const marker = new google.maps.Marker({
                position: userCenter,
                map,
                icon: "/images/user_location_pin.svg",
              });

              locationBtn.classList.remove("eui-d-none");
              $(locationBtn).on("click", () => {
                map.setCenter(userCenter);
                _updateZoomLevel();
                _setLatLngInfo();
              });

              permissionGranted = true;
            }, 500);
          },
          () => {}
        );
      }
    });
}

async function _setLatLngInfo() {
  lat = map.getCenter().lat();
  lng = map.getCenter().lng();
}

function _updateMapUIMarkers() {
  markerElement.classList.remove("mapLocation__marker--disabled");
  markerElement.classList.remove("mapLocation__marker--animation");
  mapSaveLocationBtn.disabled = false;
  const newWidthHeight = _getCalculatedRadiusWidthHeight();

  radiusElement.style.width = `${newWidthHeight}px`;
  radiusElement.style.height = `${newWidthHeight}px`;
  radiusElement.classList.add("mapLocation__radius--animation");
  markerElement.classList.add("mapLocation__marker--animation");
}

function _updateRadius() {
  const newWidthHeight = _getCalculatedRadiusWidthHeight();

  radiusElement.style.width = `${newWidthHeight}px`;
  radiusElement.style.height = `${newWidthHeight}px`;
}

function _getCalculatedRadiusWidthHeight() {
  const bounds = map.getBounds();
  const NECorner = bounds.getNorthEast();
  const SWCorner = bounds.getSouthWest();
  const NWCorner = new google.maps.LatLng(NECorner.lat(), SWCorner.lng());

  const φ1 = (NECorner.lat() * Math.PI) / 180;
  const φ2 = (NWCorner.lat() * Math.PI) / 180;
  const Δφ = ((NWCorner.lat() - NECorner.lat()) * Math.PI) / 180;
  const Δλ = ((NWCorner.lng() - NECorner.lng()) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = EARTH_RADIUS * c;
  const mapWidth = map.getDiv().offsetWidth;
  const newWidthHeight = (radius * 2 * mapWidth) / distance;

  return newWidthHeight;
}

function _updateZoomLevel() {
  const lat = map.getCenter().lat();
  const lng = map.getCenter().lng();

  const earthRadiusMeters = EARTH_RADIUS * 1000;
  const latDist = (earthRadiusMeters * Math.PI) / 180;
  const lngDist =
    ((earthRadiusMeters * Math.PI) / 180) * Math.cos((lat * Math.PI) / 180);

  const areaRadius = radius * 1000;

  const latitudeRangeDelta = areaRadius / latDist;
  const longitudeRangeDelta = areaRadius / lngDist;

  const bounds = new google.maps.LatLngBounds();
  const latLng1 = new google.maps.LatLng(
    lat - latitudeRangeDelta,
    lng - longitudeRangeDelta
  );
  const latLng2 = new google.maps.LatLng(
    lat + latitudeRangeDelta,
    lng + longitudeRangeDelta
  );
  bounds.extend(latLng1);
  bounds.extend(latLng2);

  map.fitBounds(bounds);
}

async function _updateInput() {
  try {
    mapSaveLocationBtn.disabled = true;
    const detailsResponse = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCS-CeB0NPJuMhxEUShU9og8WQpDF8vMug`
    );
    const details = await detailsResponse.json();
    const postalCodeDetails = details.results.find((result) =>
      result.types.includes("postal_code")
    );

    const townDetails = details.results.find((result) =>
      result.types.includes("locality")
    );

    const countryDetails = details.results.find((result) =>
      result.types.includes("country")
    );
    postalCode = postalCodeDetails.address_components[0].long_name;
    townName = townDetails
      ? townDetails.address_components[0].long_name
      : postalCodeDetails.address_components[1].long_name;
    province = postalCodeDetails.address_components[2].long_name;
    const countryCodeGoogle = countryDetails.address_components[0].short_name;

    if (_isSpain()) {
      if (countryCodeGoogle !== "ES") {
        const errorPositionCountryMessage = $("#registerStep3Form").attr(
          "data-error-country-message"
        );
        addToast(errorPositionCountryMessage, "error", 3000);
        return false;
      }
      countryCode = "011";
    }
    if (_isPortugal()) {
      if (countryCodeGoogle !== "PT") {
        const errorPositionCountryMessage = $("#registerStep3Form").attr(
          "data-error-country-message"
        );
        addToast(errorPositionCountryMessage, "error", 3000);
        return false;
      }
      countryCode = "010";
    }

    mapSaveLocationBtn.disabled = false;

    return true;
  } catch (error) {
    mapSaveLocationBtn.disabled = true;
    const errorPositionMessage = $("#registerStep3Form").attr(
      "data-error-position-message"
    );
    addToast(errorPositionMessage, "error", 3000);
    return false;
  }
}

async function _updateFormInfo() {
  const validPosition = await _updateInput();
  if (!validPosition) return;

  const eventDetails = {
    lat,
    lng,
    postalCode,
    countryCode,
    townName,
    radius,
    province,
  };
  const mapInfoEvent = new CustomEvent("mapInfo", {
    detail: eventDetails,
  });
  document.dispatchEvent(mapInfoEvent);
}

document.addEventListener(
  "setMapInfo",
  (mapInfo) => {
    lat = mapInfo.detail.lat;
    lng = mapInfo.detail.lng;
    postalCode = mapInfo.detail.postalCode;
    townName = mapInfo.detail.townName;
    radius = mapInfo.detail.radius;

    const pos = {
      lat,
      lng,
    };

    map.setCenter(pos);

    updateSlider($(MAP_RADIUS_SLIDER)[0], radius);
    $(MAP_RADIUS_SLIDER).val(radius);
    updateRadius(radius);
    _setLatLngInfo();
  },
  false
);

function _isSpain() {
  return window.location.pathname.includes("/es");
}

function _isPortugal() {
  return window.location.pathname.includes("/pt");
}

const MAP_STYLES = [
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6195a0",
      },
    ],
  },
  {
    featureType: "administrative.province",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        lightness: "0",
      },
      {
        saturation: "0",
      },
      {
        color: "#f5f5f2",
      },
      {
        gamma: "1",
      },
    ],
  },
  {
    featureType: "landscape.man_made",
    elementType: "all",
    stylers: [
      {
        lightness: "-3",
      },
      {
        gamma: "1.00",
      },
    ],
  },
  {
    featureType: "landscape.natural.terrain",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#bae5ce",
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "all",
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: 45,
      },
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#fac9a9",
      },
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text",
    stylers: [
      {
        color: "#4e4e4e",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#787878",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "transit.station.airport",
    elementType: "labels.icon",
    stylers: [
      {
        hue: "#0a00ff",
      },
      {
        saturation: "-77",
      },
      {
        gamma: "0.57",
      },
      {
        lightness: "0",
      },
    ],
  },
  {
    featureType: "transit.station.rail",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#43321e",
      },
    ],
  },
  {
    featureType: "transit.station.rail",
    elementType: "labels.icon",
    stylers: [
      {
        hue: "#ff6c00",
      },
      {
        lightness: "4",
      },
      {
        gamma: "0.75",
      },
      {
        saturation: "-68",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        color: "#eaf6f8",
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#c7eced",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        lightness: "-49",
      },
      {
        saturation: "-53",
      },
      {
        gamma: "0.79",
      },
    ],
  },
];
